import { render, staticRenderFns } from "./FIRDetails.vue?vue&type=template&id=caf0f192"
import script from "./FIRDetails.vue?vue&type=script&lang=js"
export * from "./FIRDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports